import { useEffect, useState } from 'react';

import { useMsal } from '@azure/msal-react';

import { appTheme } from './Helpers/customRevealTheme';
import { darkPowerONTheme, brandPowerON } from './Helpers/fluentPowerONTheme';

import { useSignInState } from './Components/signInState';
import LoadingPage from './Components/LoadingPage';
import useFetch from './Hooks/useFetchAPI';
import useRevealHeaders from './Hooks/useRevealHeaders';
import useAlerts from './Hooks/useAlerts';
import AlertModal from './Components/AlertModal';
import { Alert } from './Types/alert';
import { Button, MessageBar, MessageBarActions, MessageBarBody } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { addAlertMenuItemToVisualization } from './Helpers/utils';

// import './IntuneDashboards.css'

declare let $: any;

const HomeDash = (props: any) => {
    const dashboardURL = `${process.env.REACT_APP_REVEAL_DATA_URL}dashboards`;
    $.ig.RevealSdkSettings.setBaseUrl(process.env.REACT_APP_REVEAL_BASE_URL);
    $.ig.RevealSdkSettings.enableActionsOnHoverTooltip = true;

    const { inProgress } = useMsal();
    const { signInState } = useSignInState();
    const dashboardId = "Home"; // Default to "Home"
    const [dashboards, setDashboards] = useState<DashboardDataResult[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { getRevealHeaders } = useRevealHeaders();
    const { currentAlert, setCurrentAlert, createAlert, createAlertData } = useAlerts();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');

    const { fetchAPI: fetchDashboards, apiData: dashboardData, isLoading: isLoadingDashboards, serverError: serverErrorDashboards } = useFetch({ scope: 'AppUser' })

    useEffect(() => {
        $.ig.RevealSdkSettings.theme = appTheme(signInState.userInfo[0]?.ThemePreference);
        darkPowerONTheme.colorBrandForeground1 = brandPowerON[110]; // use brand[110] instead of brand[100]
        darkPowerONTheme.colorBrandForeground2 = brandPowerON[120]; // use brand[120] instead of brand[110]
    }, [signInState.userInfo[0]?.ThemePreference]);

    useEffect(() => {
        const revealHeaders = async () => {
            const headers = await getRevealHeaders();
            $.ig.RevealSdkSettings.setAdditionalHeadersProvider(() => headers);
        };
        if (inProgress === 'none') {
            setIsLoading(true);
            revealHeaders()
                .then(() => {
                    setIsLoading(false);
                });
        }
    }, [inProgress, props.currentCustomerID]);

    useEffect(() => {
        setDashboards([])
        const fetchDashList = async () => {
            await fetchDashboards({ url: dashboardURL, method: 'GET' });
        };
        fetchDashList()
            .catch((error) => {
                console.error('Error fetching dashboards', error);
                setDashboards([]);
            });
    }, [props.currentCustomerID]);

    const updateRevealView = (revealView: any) => {
        revealView.onLinkedDashboardProviderAsync = (dashboardId: string) => {
            return $.ig.RVDashboard.loadDashboard(dashboardId);
        };

        addAlertMenuItemToVisualization(revealView, signInState, setCurrentAlert);
    }

    useEffect(() => {
        if (currentAlert) {
            setIsModalOpen(true);
        }
    }, [currentAlert]);

    useEffect(() => {
        if (!isLoading) {
            $.ig.RVDashboard.loadDashboard(dashboardId).then((dashboard: any) => {
                const revealView = new $.ig.RevealView('#revealView');
                revealView.dashboard = dashboard;
                revealView.canEdit = false;
                revealView.canSaveAs = false;

                updateRevealView(revealView);
            });
        }
    }, [dashboardId, isLoading, props.currentCustomerID]);

    useEffect(() => {
        console.log('[IntuneDashboards] dashboards:', dashboardData);
        setDashboards(dashboardData as unknown as DashboardDataResult[]);
    }, [dashboardData]);

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCurrentAlert(null);
    };

    const handleSaveAlert = async (updatedAlert: any) => {
        try {
            await createAlert(updatedAlert);
            handleCloseModal();
        } catch (error) {
            console.error('Error saving alert:', error);
        }
    };

    useEffect(() => {
        if (createAlertData) {
            setNotificationMessage('Alert created successfully');
        }
    }, [createAlertData]);

    return (
        <div className='Dashboard'>
            {notificationMessage && (
                <MessageBar intent={'success'}>
                <MessageBarBody>
                    {notificationMessage}
                </MessageBarBody>
                <MessageBarActions
                    containerAction={
                        <Button
                            onClick={() => setNotificationMessage('')}
                            aria-label="dismiss"
                            appearance="transparent"
                            icon={<DismissRegular />}
                        />
                    }
                />
            </MessageBar>
            )}
            {isLoadingDashboards && <LoadingPage message="Loading Home Dashboard..." />}
            {!isLoadingDashboards && dashboards &&
                <>
                    <div id='revealView' style={{ height: 'calc(100vh - 100px)', width: '100%' }}></div>
                </>
            }
            {currentAlert && (
                <AlertModal
                    alert={currentAlert as Alert}
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onSave={handleSaveAlert}
                    title={`Create Alert: ${currentAlert.AlertTitle}`}
                />
            )}
        </div>
    );
};

export default HomeDash;